'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refineAttributes = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var refineAttributes = exports.refineAttributes = function refineAttributes(parsedAttributes, seriesCombinations) {
  var indexedRelationships = R.reduce(function (acc, comb) {
    return R.reduce(function (_acc, concept) {
      return R.assoc(concept, comb.relationship, _acc);
    }, acc, comb.concepts);
  }, {}, seriesCombinations);
  return R.map(function (attr) {
    if (R.has(attr.id, indexedRelationships)) {
      return (0, _extends3.default)({}, attr, { series: true, relationship: R.prop(attr.id, indexedRelationships), combined: true });
    }
    return attr;
  }, parsedAttributes);
};